import { createContext, useContext, useState, useEffect } from 'react';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [client, setClient] = useState(() => {
    try { return JSON.parse(localStorage.getItem('shaheen_client')); } catch { return null; }
  });

  const login = (clientData) => {
    setClient(clientData);
    localStorage.setItem('shaheen_client', JSON.stringify(clientData));
  };

  const logout = () => {
    const token = localStorage.getItem('shaheen_token');
    if (token) {
      const base = process.env.REACT_APP_API_URL || 'https://web-production-120c.up.railway.app';
      fetch(`${base}/logout`, { method: 'POST', headers: { 'Authorization': `Bearer ${token}` } }).catch(() => {});
    }
    setClient(null);
    localStorage.removeItem('shaheen_client');
    localStorage.removeItem('shaheen_token');
  };

  return <AuthCtx.Provider value={{ client, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
